export default [
  {
    path: '/settings/auditoria/logs',
    name: 'audit-logs',
    component: () => import('@/views/settings/audit/AuditLogsList.vue'),
    meta: {
      action: 'ROLE_CORE_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Logs de Auditoria',
      breadcrumb: [
        {
          text: 'Configurações',
        },
        {
          text: 'Auditoria',
        },
        {
          text: 'Logs',
          active: true,
        },
      ],
    },
  },
];
